<template>
  <div class="home-announcements">
    <article
      v-for="(ann, i) in announcementList"
      :key="i"
      class="home-announcement-card glass-panel"
    >
      <div class="home-announcement-card__icon" aria-hidden="true">
        <v-icon size="30" class="home-announcement-card__icon-mark">mdi-bullhorn-outline</v-icon>
      </div>
      <div class="home-announcement-card__body">
        <h4
          v-if="ann.title"
          class="home-announcement-card__title"
          v-html="parseMarkdown(ann.title)"
        ></h4>
        <div
          v-if="ann.content"
          class="home-announcement-card__content"
          v-html="parseMarkdown(ann.content)"
        ></div>
      </div>
    </article>
  </div>
</template>

<script>
import { parseMarkdown } from "@/utils/parseMarkdown.js";

export default {
  name: "HomeNotification",
  props: {
    announcements: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    announcementList() {
      return Array.isArray(this.announcements) ? this.announcements : [];
    },
  },
  methods: {
    parseMarkdown,
  },
};
</script>
<style src="./homenotification.css"></style>
